import script from "./ABotaoDeAcao.vue?vue&type=script&setup=true&lang=ts"
export * from "./ABotaoDeAcao.vue?vue&type=script&setup=true&lang=ts"

import "./ABotaoDeAcao.vue?vue&type=style&index=0&id=6b1333ab&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1333ab"]])

export default __exports__